import { I as Icon, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';
import 'styled-components';

var CloseIcon = function (props) { return (React.createElement(Icon, __assign({}, props, { viewBox: "0 0 512 512" }),
    React.createElement("path", { d: "M403.1 108.9c-81.2-81.2-212.9-81.2-294.2 0s-81.2 212.9 0 294.2c81.2 81.2 212.9 81.2 294.2 0s81.2-213 0-294.2zm-12.3 281.9c-74.3 74.3-195.3 74.3-269.6 0-74.3-74.3-74.3-195.3 0-269.6s195.3-74.3 269.6 0c74.4 74.3 74.4 195.3 0 269.6z" }),
    React.createElement("path", { d: "M340.2 160l-84.4 84.2-84-83.8-11.8 11.8 84 83.8-84 83.8 11.8 11.8 84-83.8 84.4 84.2 11.8-11.8-84.4-84.2 84.4-84.2z" }))); };

export { CloseIcon as default };
